import { PlayButton } from '@southfields-digital/mxmz-react-ui';
import classNames from 'classnames';

import styles from '../MatchControl.module.scss';

import AdjustButton from './AdjustButton';

type ExtraInProps = {
  isRunning?: boolean;
  handleChangeExtraTime: (amount: number) => void;
  handleToggleIsExtraTimeLive: () => void;
  extraTime: number;
  isCompact?: boolean;
};

const ExtraIn = ({
  isRunning = false,
  handleChangeExtraTime,
  handleToggleIsExtraTimeLive,
  extraTime,
  isCompact = false,
}: ExtraInProps) => (
  <div className={styles.ExtraInWrapper}>
    <div className={styles.ActionsWrapper}>
      <AdjustButton
        isCompact={isCompact}
        onClick={() => handleChangeExtraTime(-1000)}
        iconProps={{ icon: 'minus', weight: 'bold', size: isCompact ? 14 : 20 }}
        disabled={extraTime <= 0}
      />

      <AdjustButton
        isCompact={isCompact}
        onClick={() => handleChangeExtraTime(1000)}
        iconProps={{ icon: 'plus', weight: 'bold', size: isCompact ? 14 : 20 }}
      />
    </div>
    <PlayButton
      isRunning={isRunning}
      onClick={handleToggleIsExtraTimeLive}
      className={classNames(
        'w-full place-content-center',
        isCompact ? '!h-7 !text-sm' : '!h-9 !text-lg'
      )}
    >
      EXTRA
    </PlayButton>
  </div>
);

export default ExtraIn;
